import type { ReactNode } from 'react'

type Props = {
  expanded: boolean
  compact: ReactNode
  expandedPane: ReactNode
}

/**
 * 紧凑 / 展开双层叠放 + CSS 透明度过渡，与外壳 width/padding 同步，避免内外各播一段动画。
 */
export function ThemeDynamicIslandMorph({ expanded, compact, expandedPane }: Props) {
  return (
    <div
      className={[
        'glyphicai-dynamic-island__stack',
        expanded ? 'glyphicai-dynamic-island__stack--expanded' : 'glyphicai-dynamic-island__stack--compact',
      ].join(' ')}
    >
      <div
        className={[
          'glyphicai-dynamic-island__pane',
          'glyphicai-dynamic-island__pane--compact',
          expanded ? '' : 'glyphicai-dynamic-island__pane--active',
        ]
          .filter(Boolean)
          .join(' ')}
        aria-hidden={expanded}
      >
        {compact}
      </div>
      <div
        className={[
          'glyphicai-dynamic-island__pane',
          'glyphicai-dynamic-island__pane--expanded',
          expanded ? 'glyphicai-dynamic-island__pane--active' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        aria-hidden={!expanded}
      >
        {expandedPane}
      </div>
    </div>
  )
}
